// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextArea_wrapper__2KVC4","message":"TextArea_message__1T9y-","input":"TextArea_input__2tRKH","textArea":"TextArea_textArea__2WQzI","checkbox":"TextArea_checkbox__25BST"};